import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import './productindex.css';
import { useDispatch, useSelector } from 'react-redux';

//components
import { AccordionItem } from '../../components/common/Accordion';
import { DropDown, Option } from '../../components/common/DropDown';
import Banner from '../../components/common/ShowBannerDetails';
import ProductImage from '../../components/common/ProductImage';
import { Scrollbars } from 'react-custom-scrollbars-2';
//api
import { filterProductsBySchool } from '../../api/productapi';  //filterProductsByDistrict
import { allCategoriesForSchool } from '../../api/categoriesapi'; //allCategories,getAllBySlugs
//helpers
import { checkForDistrictId, isDemoDistrict, getDistrictPath } from '../../helpers/checkForDistrictId';
import { formatUSD } from '../../helpers/formatterHelper';
import { updateTitle, updateMetaDescription } from '../../helpers/titleHelper';
import { gtmViewProduct } from '../../helpers/gtmHelper';
import { getAllDistrictSchoolsByUserId } from '../../api/schoolsApi';
import { setSelectedSchool, setSelectedSchoolName } from '../../store/school-reducer';
import { renderStars } from '../../helpers/reviewHelper';
import RatingField from '../review/ratingField';

export default function Products() {
    updateTitle('Top Facility Management Products');
    updateMetaDescription("Browse Facility Standard's range of facility management products designed to streamline operations and improve efficiency. Find the perfect solution for your needs today!");
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { selectedSchool } = useSelector((state) => state.schools);
    const [filter, setFilter] = useState({
        start: 1,
        length: 20,
        orderby: 4,
        categoryIds: [],
        manufacturerIds: [],
        dealerIds: [],
        schoolId: 0,
        overallRating: 0,
        durabilityRating: 0,
        comfortRating: 0,
        functionalityRating: 0,
        valueRating: 0,

    });
    const [products, setProducts] = useState({ total: 0, results: [] });
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const [scroll, setScroll] = useState({
        hasScroll: false,
        foundBottom: false,
        totalProducts: 0,
    });
    const productsRef = React.useRef(products);
    const scrollRef = React.useRef(scroll);
    const [showMore, setShowMore] = useState({ 0: false, 1: false, 2: false });
    const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
    const [isMobileSortByOpen, setIsMobileSortByOpen] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(true);
    const [showLoginModal, setShowLoginModal] = useState(true);

    const { siteUserId, isDealer } = useSelector((state) => state.auth);
    const [schools, setSchools] = useState([]);
    var district = {};
    const districtJson = localStorage.getItem('district') ?? '';
    if (districtJson != '') {
        district = JSON.parse(districtJson);
    }

    useEffect(() => {
        let districtId = localStorage.getItem('districtId');
        getAllDistrictSchoolsByUserId(districtId, siteUserId).then(res => {
            if (res.data?.success) {
                const schools = res.data.data;
                if (schools && schools.length === 0) {
                    dispatch(setSelectedSchool(0));
                    dispatch(setSelectedSchoolName(''));
                    setShowLoginModal(true);
                }
                setSchools(schools);
                setIsLoading(false);
            }
        });
    }, [siteUserId]);

    const handleSchoolChange = (e) => {
        const selectedValue = e.target.value;
        if (selectedValue !== '') {
            const schoolId = parseInt(selectedValue);
            const selectedSchool = schools.find(school => school.baseId === schoolId);
            const schoolName = selectedSchool ? selectedSchool.name : '';

            dispatch(setSelectedSchool(schoolId));
            dispatch(setSelectedSchoolName(schoolName));

            scrollRef.foundBottom = false;
            setProducts({ total: 0, results: [] });
            setScroll({ ...scroll, foundBottom: false });
            setFilter({ ...filter, schoolId: parseInt(selectedValue), start: 1 });
            document.body.scrollTo({ top: 0, behavior: 'smooth' });
            setShowLoginModal(false);
        }
    };

    useEffect(() => {
        //if (slugs && filter.categoryIds.length == 0) { return; } 
        if (filter.schoolId === 0) { return; }
        let editTypicalLayout = localStorage.getItem('typicallayout');
        let typicalProductDetails = JSON.parse(localStorage.getItem('editTypicalLayout')) || [];
        let districtID = editTypicalLayout && typicalProductDetails && typicalProductDetails.districtId ? typicalProductDetails.districtId : localStorage.getItem('districtId');
        setIsRefreshing(true);
        filterProductsBySchool(
            districtID,
            filter.schoolId,
            filter.start,
            filter.length,
            filter.orderby,
            filter.categoryIds,
            filter.manufacturerIds,
            filter.dealerIds,
            filter.overallRating,
            filter.durabilityRating,
            filter.comfortRating,
            filter.functionalityRating,
            filter.valueRating,
        )
            .then((response) => {
                var p = response.data.data;
                var prods = {};
                if (filter.start === 1) {
                    prods = {
                        total: p.total,
                        results: p.results,
                    };
                } else {
                    const merged = products.results.length > 0 ? [...products.results, ...p.results] : p.results;
                    const unique = Array.from(
                        new Map(merged.map(prod => [prod.id, prod])).values()
                    );
                    prods = {
                        total: p.total,
                        results: unique,
                    };
                }

                setIsFetching(false);
                setProducts({ ...prods });
                productsRef.total = prods.total;
                productsRef.results = prods.results;
                allCategoriesForSchool(filter.categoryIds, 0, filter.schoolId)
                    .then((cats) => {
                        setCategories(cats.data.data);
                    })
                    .catch((err) => {
                        setError('Error fetching categories: ' + err);
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
                if (filter.start === 1) {
                    document.body.scrollTo({ top: 0, behavior: 'smooth' });
                }
                setIsRefreshing(false);
            })
            .catch((err) => {
                setError('Error fetching district products: ' + err);
            });
    }, [filter]);

    useEffect(() => {
        let plen = products.results.filter((a) => a.details).length;
        if (plen > scroll.totalProducts) {
            setScroll({ ...scroll, foundBottom: false, totalProducts: plen });
            scrollRef.foundBottom = false;
            scrollRef.totalProducts = plen;
        }
    }, [products]);

    const fetchMoreProducts = () => {
        if (filter.start < products.total && !isFetching && !isRefreshing) {
            setIsFetching(true);
            setFilter((prev) => ({ ...prev, start: prev.start + prev.length }));
        }
    };

    const updateFilteredCategories = (e, id) => {
        var isChecked = e.target.checked;
        var c = filter.categoryIds;
        if (isChecked) {
            c.push(id);
        } else {
            c = c.filter((a) => a != id);
        }
        scrollRef.foundBottom = false;
        setProducts({ total: 0, results: [] });
        setScroll({ ...scroll, foundBottom: false });
        const uFilter = { ...filter, start: 1, categoryIds: c };
        setFilter(uFilter);
        document.body.scrollTo({ top: 0, behavior: 'smooth' });
        updateUrl(uFilter);
    };

    const updateFilteredManufacturers = (e, id) => {
        const isChecked = e.target.checked;
        let m = [...filter.manufacturerIds];

        if (isChecked) {
            m.push(id);
        } else {
            m = m.filter(a => a !== id);
        }

        setProducts({ total: 0, results: [] });
        setScroll({ ...scroll, foundBottom: false });

        const uFilter = { ...filter, start: 1, manufacturerIds: m };
        setFilter(uFilter);
        document.body.scrollTo({ top: 0, behavior: 'smooth' });
        updateUrl(uFilter);
    };
    const updateFilteredDealers = (e, id) => {
        const isChecked = e.target.checked;
        let d = [...(filter.dealerIds || [])];

        if (isChecked) {
            d.push(id);
        } else {
            d = d.filter(a => a !== id);
        }

        setProducts({ total: 0, results: [] });
        setScroll(prev => ({ ...prev, foundBottom: false }));
        const uFilter = { ...filter, start: 1, dealerIds: d };
        setFilter(uFilter);
        document.body.scrollTo({ top: 0, behavior: 'smooth' });
        updateUrl(uFilter);
    };


    const handleRatingChange = (name, value) => {
        const selectedStar = parseInt(value);

        scrollRef.foundBottom = false;
        setProducts({ total: 0, results: [] });
        setScroll({ ...scroll, foundBottom: false });

        const uFilter = {
            ...filter,
            start: 1,
            [name]: selectedStar,
        };
        setFilter(uFilter);
        document.body.scrollTo({ top: 0, behavior: 'smooth' });
        updateUrl(uFilter);
    };

    const updateOrderBy = (x) => {
        setProducts({ total: 0, results: [] });
        setScroll({ ...scroll, foundBottom: false });
        const uFilter = { ...filter, start: 1, orderby: x };
        setFilter(uFilter);
        updateUrl(uFilter);
    };



    const updateUrl = (updatedFilter) => {

        let queryString = [];
        if (updatedFilter.categoryIds?.length) queryString.push(`c=${updatedFilter.categoryIds.join(",")}`);
        if (updatedFilter.manufacturerIds?.length) queryString.push(`m=${updatedFilter.manufacturerIds.join(",")}`);
        if (updatedFilter.dealerIds?.length) queryString.push(`d=${updatedFilter.dealerIds.join(",")}`);
        if (updatedFilter.overallRating > 0) queryString.push(`or=${updatedFilter.overallRating}`);
        if (updatedFilter.durabilityRating > 0) queryString.push(`dr=${updatedFilter.durabilityRating}`);
        if (updatedFilter.comfortRating > 0) queryString.push(`cr=${updatedFilter.comfortRating}`);
        if (updatedFilter.functionalityRating > 0) queryString.push(`fr=${updatedFilter.functionalityRating}`);
        if (updatedFilter.valueRating > 0) queryString.push(`vr=${updatedFilter.valueRating}`);
        queryString.push(`sort=${updatedFilter.orderby}`);
        if (isDemoDistrict()) queryString.push(`org=${getDistrictPath()}`);

        const urlParams = queryString.join("&");
        const newUrl = `/products${urlParams ? `?${urlParams}` : ''}`;
        history.replaceState(null, '', newUrl);
    }

    useEffect(() => {
        checkForDistrictId(navigate); //redirect to admin/districts if user is not logged into district

        const updateFilter = {
            ...filter,
            start: 1,
            categoryIds: searchParams.get('c') ? searchParams.get('c').split(",").map(Number) : [],
            manufacturerIds: searchParams.get('m') ? searchParams.get('m').split(",").map(Number) : [],
            dealerIds: searchParams.get('d') ? searchParams.get('d').split(",").map(String) : [],
            overallRating: searchParams.get('or') ? parseInt(searchParams.get('or')) : 0,
            durabilityRating: searchParams.get('dr') ? parseInt(searchParams.get('dr')) : 0,
            comfortRating: searchParams.get('cr') ? parseInt(searchParams.get('cr')) : 0,
            functionalityRating: searchParams.get('fr') ? parseInt(searchParams.get('fr')) : 0,
            valueRating: searchParams.get('vr') ? parseInt(searchParams.get('vr')) : 0,
            orderby: searchParams.get('sort') ? parseInt(searchParams.get('sort')) : 4,
            schoolId: selectedSchool
        };
        setFilter(updateFilter);
    }, [searchParams]);

    const clearFilter = () => {
        scrollRef.foundBottom = false;
        setProducts({ total: 0, results: [] });
        setScroll({ ...scroll, foundBottom: false });

        const uFilter = {
            ...filter,
            start: 1,
            length: 20,
            categoryIds: [],
            manufacturerIds: [],
            dealerIds: [],
            overallRating: 0,
            durabilityRating: 0,
            comfortRating: 0,
            functionalityRating: 0,
            valueRating: 0,
        };

        setFilter(uFilter);
        document.body.scrollTo({ top: 0, behavior: 'smooth' });
        updateUrl(uFilter);
    };

    const CategoryAccordions = () => {
        const categoryGroups = [
            { id: 0, name: 'Room Type' },
            { id: 1, name: 'Categories' },
            { id: 2, name: 'Grade Level' },
            { id: 3, name: 'Lead Time' }
        ];

        const hasManufacturers = categories && categories.length > 4 && categories[4].length > 0;
        const hasDealers = categories && categories.length > 5 && categories[5].length > 0 && !isDealer;

        return (
            <>
                {categoryGroups
                    .filter(x => categories && categories[x.id] && categories[x.id].length > 0)
                    .map((x) => (
                        <AccordionItem key={x.id} title={x.name} opened={true}>
                            <div className="product-checkboxes">
                                {categories && categories.length > x.id ? (
                                    (showMore[x.id]
                                        ? categories[x.id]
                                        : categories[x.id].slice(0, 4)
                                    ).map((c) => (
                                        <div
                                            key={'category_' + c.id}
                                            className={`product-checkbox${c.productCount === 0 ? ' disabled' : ''}`}
                                        >
                                            <label className="container-checkbox" htmlFor={'category_' + c.id}>
                                                <span className="checkbox-title">{c.name}{` (${c?.productCount})`}</span>
                                                <input
                                                    type="checkbox"
                                                    id={'category_' + c.id}
                                                    checked={filter.categoryIds.includes(c.id)}
                                                    onChange={(e) => updateFilteredCategories(e, c.id)}
                                                    disabled={c.productCount === 0}
                                                />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                    ))
                                ) : null}
                            </div>
                            {categories && categories.length > x.id &&
                                categories[x.id].length > 4 && !showMore[x.id] && (
                                    <button
                                        className="show-all-title"
                                        onClick={() => setShowMore(prev => ({ ...prev, [x.id]: true }))}
                                    >
                                        Show All
                                    </button>
                                )}
                        </AccordionItem>
                    ))
                }

                {/* Manufacturers Accordion */}
                {hasManufacturers && (
                    <AccordionItem key="manufacturers" title="Manufacturers" opened={true}>
                        <div className="product-checkboxes">
                            {(showMore.manufacturers
                                ? categories[4]
                                : categories[4].slice(0, 4)).map((m) => (
                                    <div
                                        key={'manufacturer_' + m.id}
                                        className={`product-checkbox${m.productCount === 0 ? ' disabled' : ''}`}
                                    >
                                        <label className="container-checkbox" htmlFor={'manufacturer_' + m.id}>
                                            <span className="checkbox-title">{m.name}{` (${m?.productCount})`}</span>
                                            <input
                                                type="checkbox"
                                                id={'manufacturer_' + m.id}
                                                checked={filter.manufacturerIds.includes(m.id)}
                                                onChange={(e) => updateFilteredManufacturers(e, m.id)}
                                                disabled={m.productCount === 0}
                                            />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                ))}
                        </div>
                        {categories[4].length > 4 && !showMore.manufacturers && (
                            <button
                                className="show-all-title"
                                onClick={() => setShowMore(prev => ({ ...prev, manufacturers: true }))}
                            >
                                Show All
                            </button>
                        )}
                    </AccordionItem>
                )}

                {/* Dealers Accordion */}
                {hasDealers && (
                    <AccordionItem key="dealers" title="Dealers" opened={true}>
                        <div className="product-checkboxes">
                            {(showMore.dealers
                                ? categories[5]
                                : categories[5].slice(0, 4)).map((d) => (
                                    <div
                                        key={'dealer_' + d.dealerId}
                                        className={`product-checkbox${d.productCount === 0 ? ' disabled' : ''}`}
                                    >
                                        <label className="container-checkbox" htmlFor={'dealer_' + d.dealerId}>
                                            <span className="checkbox-title">{d.name}{` (${d?.productCount})`}</span>
                                            <input
                                                type="checkbox"
                                                id={'dealer_' + d.dealerId}
                                                checked={filter.dealerIds?.includes(d.dealerId) || false}
                                                onChange={(e) => updateFilteredDealers(e, d.dealerId)}
                                                disabled={d.productCount === 0}
                                            />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                ))}
                        </div>
                        {categories[5].length > 4 && !showMore.dealers && (
                            <button
                                className="show-all-title"
                                onClick={() => setShowMore(prev => ({ ...prev, dealers: true }))}
                            >
                                Show All
                            </button>
                        )}
                    </AccordionItem>
                )}

                {/* Rating Accordion */}
                {district?.isReviewVisible && (
                    <AccordionItem title="Ratings" opened={true}>

                        <RatingField
                            label="Overall"
                            name="overallRating"
                            showUpText={true}
                            value={filter?.overallRating}
                            onChange={(name, value) => handleRatingChange(name, value)}
                        />
                        <RatingField
                            label="Durability"
                            name="durabilityRating"
                            showUpText={true}
                            value={filter?.durabilityRating}
                            onChange={(name, value) => handleRatingChange(name, value)}
                        />
                        <RatingField
                            label="Comfort"
                            name="comfortRating"
                            showUpText={true}
                            value={filter?.comfortRating}
                            onChange={(name, value) => handleRatingChange(name, value)}
                        />
                        <RatingField
                            label="Functionality"
                            name="functionalityRating"
                            showUpText={true}
                            value={filter?.functionalityRating}
                            onChange={(name, value) => handleRatingChange(name, value)}
                        />
                        <RatingField
                            label="Value"
                            name="valueRating"
                            showUpText={true}
                            value={filter?.valueRating}
                            onChange={(name, value) => handleRatingChange(name, value)}
                        />

                    </AccordionItem>
                )}
            </>
        );
    };

    const SelectedCategories = () => {
        const categoryLookup = React.useMemo(() => {
            const lookup = {};
            categories.forEach((catGroup) => {
                catGroup?.forEach((cat) => {
                    lookup[cat.id] = { name: cat.name, type: 'category' };
                });
            });
            return lookup;
        }, [categories, filter.manufacturerIds]);

        const handleRemoveFilter = useCallback((id, type) => {
            if (type === 'category') {
                const uFilter = {
                    ...filter,
                    categoryIds: filter.categoryIds.filter(categoryId => categoryId !== id),
                    start: 1
                }
                setFilter(uFilter);
                updateUrl(uFilter);
            } else if (type === 'manufacturer') {
                const uFilter = {
                    ...filter,
                    manufacturerIds: filter.manufacturerIds.filter(manId => manId !== id),
                    start: 1
                }
                setFilter(uFilter);
                updateUrl(uFilter);
            } else if (type === 'dealer') {
                const uFilter = {
                    ...filter,
                    dealerIds: filter.dealerIds.filter(dealerId => dealerId !== id),
                    start: 1
                }
                setFilter(uFilter);
                updateUrl(uFilter);
            }
            setProducts({ total: 0, results: [] });
            setScroll(prev => ({ ...prev, foundBottom: false }));
            document.body.scrollTo({ top: 0, behavior: 'smooth' });
        }, []);

        return (
            <>
                {filter.categoryIds.map((c) => {
                    const item = categoryLookup[c];
                    if (item?.type === 'category') {
                        return (
                            <div
                                className="product-filter-active"
                                key={'filter_' + c}
                                onClick={() => handleRemoveFilter(c, 'category')}
                            >
                                {item.name}
                            </div>
                        );
                    }
                    return null;
                })}

                {filter.manufacturerIds.map((m) => {
                    // Find manufacturer name (assuming it's in the last categories group)
                    const manufacturer = categories[4]?.find(man => man.id === m);
                    if (manufacturer) {
                        return (
                            <div
                                className="product-filter-active"
                                key={'manufacturer_' + m}
                                onClick={() => handleRemoveFilter(m, 'manufacturer')}
                            >
                                {manufacturer.name}
                            </div>
                        );
                    }
                    return null;
                })}

                {filter.dealerIds?.map((d) => {
                    const dealer = categories[5]?.find(dlr => dlr.dealerId === d);
                    if (dealer) {
                        return (
                            <div
                                className="product-filter-active"
                                key={'dealer_' + d}
                                onClick={() => handleRemoveFilter(d, 'dealer')}
                            >
                                {dealer.name}
                            </div>
                        );
                    }
                    return null;
                })}
                {filter.overallRating > 0 && (
                    <div
                        className="product-filter-active"
                        key={'rating_overallRating_' + filter.overallRating}
                        onClick={() => {
                            const uFilter = {
                                ...filter,
                                overallRating: 0,
                                start: 1
                            };
                            setFilter(uFilter);
                            updateUrl(uFilter);
                        }}
                    >
                        {`Overall ${filter.overallRating}* & Up`}
                    </div>
                )}
                {filter.durabilityRating > 0 && (
                    <div
                        className="product-filter-active"
                        key={'rating_durabilityRating_' + filter.durabilityRating}
                        onClick={() => {
                            const uFilter = {
                                ...filter,
                                durabilityRating: 0,
                                start: 1
                            };
                            setFilter(uFilter);
                            updateUrl(uFilter);
                        }}
                    >
                        {`Durability ${filter.durabilityRating}* & Up`}
                    </div>
                )}
                {filter.comfortRating > 0 && (
                    <div
                        className="product-filter-active"
                        key={'rating_comfortRating_' + filter.comfortRating}
                        onClick={() => {
                            const uFilter = {
                                ...filter,
                                comfortRating: 0,
                                start: 1
                            };
                            setFilter(uFilter);
                            updateUrl(uFilter);
                        }}
                    >
                        {`Comfort ${filter.comfortRating}* & Up`}
                    </div>
                )}
                {filter.functionalityRating > 0 && (
                    <div
                        className="product-filter-active"
                        key={'rating_functionalityRating_' + filter.functionalityRating}
                        onClick={() => {
                            const uFilter = {
                                ...filter,
                                functionalityRating: 0,
                                start: 1
                            };
                            setFilter(uFilter);
                            updateUrl(uFilter);
                        }}
                    >
                        {`Functionality ${filter.functionalityRating}* & Up`}
                    </div>
                )}
                {filter.valueRating > 0 && (
                    <div
                        className="product-filter-active"
                        key={'rating_valueRating_' + filter.valueRating}
                        onClick={() => {
                            const uFilter = {
                                ...filter,
                                valueRating: 0,
                                start: 1
                            };
                            setFilter(uFilter);
                            updateUrl(uFilter);
                        }}
                    >
                        {`Value ${filter.valueRating}* & Up`}
                    </div>
                )}
            </>
        );
    };
    const goToProduct = (p) => {
        navigate(`/products/${p.id}/${p.slug}`, { state: { from: 'results' } });
    };
    const maxColors = 6;

    const renderProductList = () => {
        //const [visibleCount, setVisibleCount] = useState(6); // Start with 25 products
        //const loadMoreProducts = () => {
        //    setVisibleCount(prevCount => prevCount + 6); // Load 25 more on click
        //};
        //const [imageError, setImageError] = useState(false);
        console.log(products.results)

        return products.results.length > 0 ? (
            <>
                {
                    products.results
                        .filter((a) => a.details && a.details.name)
                        .map((p) => {
                            const colors = p.options.filter((a) => a.type == 2).map(a => a.items).flat();
                            const averageRating = p.averageRating || 0;
                            const reviewCount = p.reviewCount || 0;

                            return (
                                <div
                                    key={'product_' + p.id}
                                    className="product-gallery-item"
                                    onClick={() => {
                                        gtmViewProduct(p);
                                        goToProduct(p);
                                    }}
                                >
                                    <span className={'product-item-image favorite'}>
                                        <ProductImage
                                            photo={p.photo}
                                            photoAlt={p.photoAlt ?? p.details.name}
                                            styles="cover-thumb"
                                        />
                                        {/*<span className="errorImage">Image Coming Soon</span>*/}
                                    </span>
                                    <span className="product-item-content">
                                        <span className="product-title-amount-wrap">
                                            <span className="product-item-title">{p.details.name}</span>
                                            <span className="product-item-amount">
                                                {formatUSD(
                                                    p.details.price -
                                                    (p.details.discount > 0
                                                        ? p.details.price * (p.details.discount / 100)
                                                        : 0)
                                                )}
                                            </span>
                                        </span>
                                        <span className='product-manufacturers-name'>{p?.manufacturerName}</span>
                                        <span className="product-color-wrap">
                                            {p.options &&
                                                p.options.length > 0 &&
                                                colors.length > 0 &&
                                                colors.slice(0, maxColors)
                                                    .filter((a) => a.color).sort((a, b) => a.color.order - b.color.order)
                                                    .map((a) => (
                                                        <span
                                                            key={'color_' + p.id + '_' + a.id}
                                                            className="color-dots"
                                                            title={a.color.name}
                                                            style={{ background: a.color.hex }}
                                                        >
                                                            {a.color.colorImage ? (
                                                                <img
                                                                    src={a.color.colorImage.previewsrc}
                                                                    style={{ height: '100%' }}
                                                                    alt={a.color.name}
                                                                />
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </span>
                                                    ))}

                                            {colors.length > maxColors && (
                                                <span className="color-dots color-plus-icon">
                                                    <span className="material-symbols-rounded">
                                                        add
                                                    </span>
                                                </span>
                                            )}

                                        </span>
                                        {district?.isReviewVisible && (
                                            <span className='product-rating'>
                                                {renderStars(averageRating)}
                                                &nbsp;
                                                <span>({reviewCount})</span>
                                            </span>
                                        )}
                                    </span>
                                </div>
                            );
                        })
                }
                {products?.results?.length < products?.total && (
                    <button onClick={fetchMoreProducts} className="load-more-btn">
                        Load More
                    </button>
                )}
            </>
        ) : isRefreshing ? <div className="no-results">Loading Results...</div> : <div className="no-results">No Results Found</div>;
    };
    const toggleMobileFilter = () => {
        setIsMobileFilterOpen((prevState) => !prevState);
    };
    const toggleMobileSortBy = () => {
        setIsMobileSortByOpen((prevState) => !prevState);
    };
    const MobileSortBy = () => {
        const options = [
            { title: 'Price: Low - High', value: 0 },
            { title: 'Price: High - Low', value: 1 },
            { title: 'Brand: (A - Z)', value: 2 },
            { title: 'Default', value: 4 },
        ];
        const [selectedOrder, setSelectedOrder] = useState(filter.orderby);
        const handleRadioChange = (value) => {
            setSelectedOrder(value);
        };

        const handleApply = () => {
            if (selectedOrder !== null) {
                updateOrderBy(selectedOrder);
            }
        };
        return (
            <div className="filters-overlay sorting-overlay">
                <div className="filters-overlay-inner">
                    <button
                        className="mobile-product-nav-close"
                        onClick={toggleMobileSortBy}
                    >
                        <span className="material-symbols-rounded">close</span>
                    </button>
                    <div className="product-filter-sort-wrap">
                        <p className="product-title">Sort By</p>
                    </div>
                    <div className="product-item product-item-sort-wrapper">
                        <div className="product-item-sort-wrap">
                            <div className="product-item product-item-sort">
                                {/* Radio */}
                                <div className="product-radios">
                                    {options.map((option, index) => (
                                        <div className="product-radio" key={'radios_' + index}>
                                            <label
                                                className="container-radio"
                                                htmlFor={`option-${option.value}`}
                                            >
                                                <span className="radio-title">{option.title}</span>
                                                <input
                                                    type="radio"
                                                    id={`option-${option.value}`}
                                                    name="product-sorting"
                                                    onChange={() => handleRadioChange(option.value)}
                                                    checked={selectedOrder === option.value}
                                                />
                                                <span className="radio"></span>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="product-item-filter cta-wrapper">
                        <div className="product-item-filter-inner-wrap">
                            <button
                                className="default-cta power default-full"
                                onClick={handleApply}
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const MobileFilter = () => {
        return (
            <div className="filters-overlay">
                <div className="filters-overlay-inner">
                    {' '}
                    {/*Removed the following -- product-inner-item product-nav*/}
                    {/*@*sticky overlay bar*@*/}
                    <div className="product-inner-overlay-bar">
                        <button
                            className="mobile-product-nav-close"
                            onClick={toggleMobileFilter}
                        >
                            <span className="material-symbols-rounded">close</span>
                        </button>
                        <div className="product-item filter-results-wrap">
                            <p className="product-title">Filter</p>
                            <div className="product-filter-controls-wrap">
                                <p className="product-results">{products.total + ' Result' + (products.total != 1 ? 's' : '')}</p>
                                {filter.categoryIds.length > 0 ? (
                                    <>
                                        <a
                                            href="javascript:"
                                            onClick={clearFilter}
                                            className="product-clear"
                                        >
                                            Clear Filters
                                        </a>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </div>
                    {/*@*scrollable area on 900 down*@*/}
                    <div className="product-item product-item-filter-wrap scrollbar-outer product-filter">
                        <Scrollbars
                            autoHeight
                            autoHeightMin={400}
                            autoHeightMax={800}
                            renderTrackHorizontal={(props) => (
                                <div {...props} className="track-horizontal" />
                            )}
                            renderTrackVertical={(props) => (
                                <div {...props} className="track-vertical" />
                            )}
                            renderThumbHorizontal={(props) => (
                                <div {...props} className="thumb-horizontal" />
                            )}
                            renderThumbVertical={(props) => (
                                <div {...props} className="thumb-vertical" />
                            )}
                            renderView={(props) => <div {...props} className="view" />}
                        >
                            <div className="product-content-center">
                                <CategoryAccordions></CategoryAccordions>

                            </div>
                        </Scrollbars>
                    </div>
                    <div className="product-item-filter cta-wrapper">
                        <div className="product-item-filter-inner-wrap">
                            <a
                                href="javascript:"
                                onClick={clearFilter}
                                className="default-cta"
                            >
                                Clear Filters
                            </a>
                            <a href="javascript:" onClick={toggleMobileFilter} className="default-cta power">
                                {products.total + ' Result' + (products.total != 1 ? 's' : '')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    if (error) {
        return <h1>{error}</h1>;
    }
    if (isLoading) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <div id="content">
            <Banner />
            {/*Filter Overlay*/}
            {isMobileFilterOpen && <MobileFilter />}
            {isMobileSortByOpen && <MobileSortBy />}
            <div className="default-outer-wrapper">
                <div className="default-center">
                    <div className="page-header-wrap">
                        <h1 className="product-main-title">Products</h1>
                        <div className="product-mobile-results-wrap">
                            <div className="product-controls-wrap">
                                <a
                                    href="javascript:"
                                    className="mobile-product-filters asf"
                                    onClick={toggleMobileFilter}
                                >
                                    Filter{' '}
                                    {filter.categoryIds.length > 0
                                        ? '(' + filter.categoryIds.length + ')'
                                        : ''}
                                </a>
                                <a
                                    className="mobile-product-sort-wrap"
                                    onClick={toggleMobileSortBy}
                                >
                                    Sort By
                                </a>
                                <div className="sort-by-wrap">
                                    <label className="sort-by-label" htmlFor="sortByDropDown">
                                        Sort By
                                    </label>
                                    <DropDown onChange={updateOrderBy} defaultValue={filter.orderby}>
                                        <Option title="Price: Low - High" value={0}></Option>
                                        <Option title="Price: High - Low" value={1}></Option>
                                        <Option title="Brand: (A - Z)" value={2}></Option>
                                        <Option title="Default" value={4}></Option>
                                    </DropDown>
                                </div>
                            </div>
                            <a
                                href="javascript:"
                                className="product-results mobile-product-results"
                            >
                                {isLoading ? '' : products.total + ' Result' + (products.total != 1 ? 's' : '')}
                            </a>
                        </div>
                    </div>
                    <div className="mobile-product-overlay-dim"></div>
                    <div className="product-wrap">
                        <div className="product-inner-item product-nav">
                            <div className="product-inner-overlay-bar">
                                <a href="javascript:" className="mobile-product-nav-close">
                                    <span className="material-symbols-rounded">close</span>
                                </a>
                                <div className="product-item filter-results-wrap">
                                    <p className="product-title">Filter</p>
                                    <div className="product-filter-controls-wrap">
                                        <p className="product-results">{products.total + ' Result' + (products.total != 1 ? 's' : '')}</p>
                                        {(filter.categoryIds.length > 0 || filter.manufacturerIds.length > 0 || filter.dealerIds.length > 0 || filter.overallRating || filter.durabilityRating || filter.comfortRating || filter.functionalityRating || filter.valueRating > 0) ? (
                                            <a
                                                href="javascript:"
                                                onClick={clearFilter}
                                                className="product-clear"
                                            >
                                                Clear Filters
                                            </a>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {filter.categoryIds.length > 0 || filter.manufacturerIds.length > 0 || filter.dealerIds.length > 0 || filter.overallRating || filter.durabilityRating || filter.comfortRating || filter.functionalityRating || filter.valueRating > 0 ? (
                                <div className="product-filter-selected">
                                    <div className="filter-list">
                                        <div className="filter-list-innner">
                                            <SelectedCategories></SelectedCategories>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}

                            <div className='product-inner-overlay-bar'>
                                <div className='product-item filter-results-wrap'>
                                    <p className="product-title">By School</p>
                                    <div className='cart-select-wrapper arrow-button'>
                                        <select className='cart-grid-select cart-select-arrow' value={selectedSchool} onChange={handleSchoolChange}>
                                            <option value="">By School</option>
                                            {schools.map(school => (
                                                <option key={`school-filter-${school.baseId}`} value={school.baseId}>{school.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="product-item product-item-filter-wrap scrollbar-outer">
                                <div className="product-content-center">
                                    <CategoryAccordions></CategoryAccordions>
                                    <div className="product-item-filter cta-wrapper">
                                        <div className="product-item-filter-inner-wrap">
                                            {filter.categoryIds.length > 0 ? (
                                                <a
                                                    href="javascript:"
                                                    onClick={clearFilter}
                                                    className="product-clear"
                                                >
                                                    Clear Filters
                                                </a>
                                            ) : (
                                                <></>
                                            )}
                                            <a href="javascript:" onClick={toggleMobileFilter} className="default-cta power">
                                                {products.total + ' Result' + (products.total != 1 ? 's' : '')}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="product-inner-item">
                            <div className="product-gallery-inner">
                                {renderProductList()}
                                <div className="product-detail-loader-spinner">
                                    {isFetching ? <div className="spinner"></div> : ''}
                                </div>
                            </div>
                            {/*Intersection Target for fetching NewProduct */}
                            {/*<ObserverTarget onIntersect={fetchMoreProducts} />*/}
                        </div>
                    </div>

                    {/* login for administrators */}

                    {selectedSchool === 0 && showLoginModal && (
                        <div className='login-administrators-modal' style={{ display: 'flex' }} >
                            <div className='product-inner-overlay-bar'>
                                <div className='product-item filter-results-wrap'>
                                    <p className="product-title">Select School to See Products</p>
                                    <div className='cart-select-wrapper arrow-button'>
                                        <select className='cart-grid-select cart-select-arrow' value={selectedSchool} onChange={handleSchoolChange}>
                                            <option value="">Select School</option>
                                            {schools.map(school => (
                                                <option key={`school-${school.baseId}`} value={school.baseId}>{school.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

function ObserverTarget({ onIntersect }) {
    const ref = React.useRef();

    React.useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const firstEntry = entries[0];
                if (firstEntry.isIntersecting) {
                    onIntersect();
                }
            },
            { threshold: 1.0, rootMargin: '0px' }
        );

        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [onIntersect]);

    return <div ref={ref}></div>;
}

ObserverTarget.propTypes = {
    onIntersect: PropTypes.func.isRequired,
};
